import type {ReactAction} from '@netx/core/bootstrap';
import {faClipboardList} from '@netx/core-icons';
import {canReviewSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionReviewIcon = faClipboardList;

/**
 * Review saved cart assets
 * @param params
 * @returns Action
 */
export const cartSavedActionReview = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-review',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.REVIEW, savedCart),
	enableTest: () => canReviewSavedCart(savedCart),
	icon: cartSavedActionReviewIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.REVIEW;
	},
	...params,
});

export default cartSavedActionReview;
